import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NetworkAdditionRoutingModule } from './network-addition-routing.module';
import { NetworkAdditionComponent } from './network-addition/network-addition.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { AddNetworkAdditionComponent } from './add-network-addition/add-network-addition.component';
import { NetworkAdditionDataTableComponent } from './network-addition-data-table/network-addition-data-table.component';
import { UpdateNetworkAdditionComponent } from './update-network-addition/update-network-addition.component';
import { MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatListModule, MatTooltipModule } from '@angular/material';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { ButtonModule, CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DeleteNetworkAdditionComponent } from './delete-network-addition/delete-network-addition.component';
import { ServiceLiveDashboardModule } from '../service-live-dashboard/service-live-dashboard.module';


@NgModule({
  declarations: [NetworkAdditionComponent, AddNetworkAdditionComponent, NetworkAdditionDataTableComponent, UpdateNetworkAdditionComponent, DeleteNetworkAdditionComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NetworkAdditionRoutingModule,
    Ng4LoadingSpinnerModule,
     MatDialogModule,
        FormsModule,
        NgbDatepickerModule,
        DataTablesModule,
        MatIconModule,
        MatListModule,
        MatTooltipModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        NgMultiSelectDropDownModule,
        MultiSelectAllModule,
        CheckBoxModule,
        ButtonModule,
        NumericTextBoxModule,
        ServiceLiveDashboardModule,
        Ng4LoadingSpinnerModule.forRoot(),
  ],
  entryComponents:[AddNetworkAdditionComponent,UpdateNetworkAdditionComponent,DeleteNetworkAdditionComponent],
})
export class NetworkAdditionModule { }
